<template>
  <div class="auto-refill-success">
    <div class="arrow-icon">
        <fa icon="long-arrow-alt-up" />
        <div class="checkmark-bg">
          <loading-complete class="complete" />
        </div>
      </div>
    <h1>Auto refill has been enabled</h1>
    <p>Your account have been updated</p>
    <el-button type="primary" class="ok-button" @click="$emit('close')">OK</el-button>
  </div>
</template>

<script>
import LoadingComplete from '@/components/shared/loaders/LoadingComplete'

export default {
  name: 'AutoRefillEnableSuccess',
  components: { LoadingComplete }
}
</script>

<style lang="scss" scoped>

  .checkmark-bg {
    width: 30px;
    height: 30px;
    background-color: white;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 0px;
    right: -10px;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    padding-right: 5px;
    box-sizing: border-box;
  }

  @keyframes check-bg {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 100;
    }
  }

  .auto-refill-success {
    width: 100%;
    background-color: white;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .arrow-icon { 
      position: relative;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      background-color: $main;
      color: white;
      border-radius: 100%;
      width: 100px;
      height: 100px;

      svg {
        position: relative;
        bottom: -20px;
        font-size: 96px;
      }
    }

    .ok-button {
      width: 100px;
      margin-top: 40px;
    }

    h1 {
      margin-top: 40px;
      margin-bottom: 5px;
    }

    p {
      font-size: 14px;
      color: $text-light;
      margin: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/saldoAndCredit/auto-refill/auto-refill-state/Success.vue